
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic05Static as ObiHydraulic05StaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-05-static.js';
 
 
 

 
 export const ObiHydraulic05Static = createComponent({
   react: React,
   tagName: 'obi-hydraulic-05-static',
   elementClass: ObiHydraulic05StaticElement,
   events: {
     
   }
  });
 
 